module.exports = __webpack_public_path__ + "static/media/logo-invoice-dark.d503d72c.svg";